module.exports = __webpack_public_path__ + "img/图层 10.9fb8d4f3.png";